import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

const KEY_TOKEN = 'access_token';
const KEY_REFRESH_TOKEN = 'refresh_token';
@Injectable({
  providedIn: 'root'
})
export class TokenService {
  constructor(public jwtHelper: JwtHelperService) {
  }
  setToken(token: string) {
    this.removeToken();
    window.localStorage.setItem(KEY_TOKEN, token);
  }
  getToken() {
    return <string>window.localStorage.getItem(KEY_TOKEN);
  }
  getRefreshToken() {
    return <string>window.localStorage.getItem(KEY_REFRESH_TOKEN);
  }
  removeToken() {
    window.localStorage.removeItem(KEY_TOKEN);
  }
  isExpired() {
    return this.jwtHelper.isTokenExpired();
  }
}
